<template>
    <div>
        <DrawablePhoto
            v-if="item.params.image"
            :image="item.params.image"
            :drawing="this.item.response && this.item.response.drawing ? this.item.response.drawing : null"
            :title="$t('Annotate image')"
            :remove-button-title="$t('Remove annotation')"
            :can-be-deleted="false"
            @change="updateDrawing"
        />
        <p v-else>{{ $t('No image set to annotate.') }}</p>
    </div>
</template>

<script>
    import DrawablePhoto from '@/components/DrawablePhoto/DrawablePhoto.vue';

    export default {
        components: { DrawablePhoto },

        props: {
            item: {
                type: Object,
                required: true,
            },
        },

        methods: {
            updateDrawing(drawing) {
                if (drawing === null) {
                    this.$delete(this.item, 'response');
                    this.$delete(this.item, 'responded');
                } else {
                    this.$set(this.item, 'response', { drawing });
                    this.$set(this.item, 'responded', true);
                }
            },
        },
    };

</script>
